import type {
  InvoiceLineKind,
  InvoicePaymentSyncStatus,
  InvoiceSource,
  InvoiceStatus,
} from '@catalyst-psa/shared';

import type { Badge } from '../../components/ui/Badge.js';

type BadgeTone = NonNullable<Parameters<typeof Badge>[0]['tone']>;
export const INVOICE_STATUS_LABELS: Record<InvoiceStatus, string> = {
  draft: 'Draft',
  in_review: 'In review',
  on_hold: 'On hold',
  sent: 'Sent',
  closed: 'Closed',
  void: 'Void',
};

export const INVOICE_STATUS_TONES: Record<InvoiceStatus, BadgeTone> = {
  draft: 'gray',
  in_review: 'amber',
  on_hold: 'red',
  sent: 'green',
  closed: 'blue',
  void: 'red',
};

/** Labels/tones for the QBO-mirrored payment state on an invoice. */
export const INVOICE_PAYMENT_STATUS_LABELS: Record<InvoicePaymentSyncStatus, string> = {
  paid: 'Paid',
  partial: 'Partially paid',
  open: 'Open',
  overdue: 'Overdue',
  not_found: 'Not found in QBO',
};

export const INVOICE_PAYMENT_STATUS_TONES: Record<InvoicePaymentSyncStatus, BadgeTone> = {
  paid: 'green',
  partial: 'amber',
  open: 'blue',
  overdue: 'red',
  not_found: 'gray',
};

export const INVOICE_LINE_KIND_LABELS: Record<InvoiceLineKind, string> = {
  subscription: 'Subscription',
  overage: 'Overage',
  time: 'Time',
  fee: 'Fee',
};

export const INVOICE_SOURCE_LABELS: Record<InvoiceSource, string> = {
  product_subscription: 'Product Subscriptions',
  managed_services: 'Managed Services',
  project: 'Projects',
  tickets: 'Tickets',
  manual: 'Manual',
};
